import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { previewPages } from '../data/previewPages';
const EASE = [0.23, 1, 0.32, 1] as const;
const arrowClass = 'h-11 w-11 items-center justify-center rounded-full bg-surface text-foreground shadow-lg transition-colors duration-150 hover:bg-primary hover:text-surface focus:outline-none focus-visible:ring-4 focus-visible:ring-primary/40';
export function InsideLook() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const total = previewPages.length;
  const page = previewPages[index];
  const go = (step: number) => {
    setDirection(step);
    setIndex(prev => (prev + step + total) % total);
  };
  return <section id="anteprima" className="w-full overflow-hidden bg-inverse px-5 py-20 sm:py-28" data-id="element-129" data-mp="39w81tdj0vrsw">
      <div className="mx-auto max-w-5xl" data-id="element-130" data-mp="3enzvvy1e0fns">
        <div className="text-center" data-id="element-131" data-mp="3ep1660akwy4g">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-highlight" data-id="element-132" data-mp="21vvn9xafj0wc">
            Sbircia dentro il materiale
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-surface sm:text-[2.6rem]" data-id="element-133" data-mp="1xw50e4o0x4x3">
            Pagine vere, <span className="italic text-highlight" data-id="element-134" data-mp="26v8ib5bgfea0">non promesse.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-sm leading-relaxed text-surface/60" data-id="element-135" data-mp="2ljuytactic2t">
            Queste sono schede reali estratte dai volumi: guarda la qualità che
            porterai in classe già domani mattina.
          </p>
        </div>

        <div className="mt-12 grid items-center gap-8 md:grid-cols-[minmax(0,1fr)_20rem] md:gap-12" data-id="element-136" data-mp="2uj9nc49fccko">
          <div className="relative mx-auto w-full max-w-sm md:max-w-md" data-id="element-137" data-mp="2pmrmhfh7sydm">
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl bg-surface shadow-page sm:rounded-3xl" data-id="element-138" data-mp="1060d2a920n1d">
              <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-139" data-mp="v8qmgr9xi5by">
                <motion.img key={page.image} src={page.image} alt={`Anteprima della pagina: ${page.title}`} custom={direction} initial={{
                opacity: 0,
                x: direction * 40
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: direction * -40
              }} transition={{
                duration: 0.28,
                ease: EASE
              }} className="absolute inset-0 h-full w-full object-contain" data-id="element-140" data-mp="2vaq80vrgw8rb" />
              </AnimatePresence>
            </div>

            <button type="button" onClick={() => go(-1)} aria-label="Pagina precedente" className={`${arrowClass} absolute top-1/2 hidden -translate-y-1/2 sm:inline-flex sm:-left-5`} data-id="element-141" data-mp="3nxu60gs57mtl">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-142" data-mp="tnyzkhhtkpf" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label="Pagina successiva" className={`${arrowClass} absolute top-1/2 hidden -translate-y-1/2 sm:inline-flex sm:-right-5`} data-id="element-143" data-mp="5sqwmjv58ond">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-144" data-mp="1q8p24bhwyqht" />
            </button>

            <div className="mt-5 flex items-center justify-center gap-4 sm:hidden" data-id="element-145" data-mp="1ldt6709k3izf">
              <button type="button" onClick={() => go(-1)} aria-label="Pagina precedente" className={`${arrowClass} inline-flex`} data-id="element-146" data-mp="1hamzxsmg1rsy">
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-147" data-mp="2919oda33xxcn" />
              </button>
              <span className="min-w-[3.5rem] text-center text-xs font-bold tabular-nums text-surface/60" aria-hidden="true" data-id="element-148" data-mp="29342o5jvir7r">
                {index + 1} / {total}
              </span>
              <button type="button" onClick={() => go(1)} aria-label="Pagina successiva" className={`${arrowClass} inline-flex`} data-id="element-149" data-mp="206uxsbd4n0e8">
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-150" data-mp="2sp0do4nhgqv9" />
              </button>
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-151" data-mp="2nxiixyc1zmiq">
            <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-highlight" data-id="element-152" data-mp="27j0zewxmjrhv">
              {page.tag}
            </span>
            <h3 className="mt-3 font-display text-2xl font-black leading-tight text-surface sm:text-3xl" data-id="element-153" data-mp="2cj6ukn33rw4p">
              {page.title}
            </h3>
            <p className="mx-auto mt-3 max-w-sm text-sm leading-relaxed text-surface/60 md:mx-0" data-id="element-154" data-mp="1ykpdv9bm7jwa">
              {page.text}
            </p>

            <p className="mt-6 text-[11px] font-bold uppercase tracking-[0.18em] text-surface/40" data-id="element-155" data-mp="2r6rygj7sxzdo">
              Pagina {index + 1} di {total}
            </p>

            <div className="mt-4 flex justify-center gap-3 md:justify-start" role="tablist" aria-label="Anteprime delle pagine" data-id="element-156" data-mp="2vag9jbvn7d3o">
              {previewPages.map((item, i) => <button key={item.image} type="button" role="tab" aria-selected={i === index} aria-label={item.title} onClick={() => {
              setDirection(i > index ? 1 : -1);
              setIndex(i);
            }} className={`h-14 w-10 overflow-hidden rounded-md border-2 transition-[border-color,opacity] duration-150 focus:outline-none focus-visible:ring-4 focus-visible:ring-primary/40 ${i === index ? 'border-primary' : 'border-surface/15 opacity-50 hover:opacity-100'}`} data-id="element-157" data-mp="2meqq38dr8ssx" data-mpi={i}>
                  <img src={item.image} alt="" className="h-full w-full object-cover object-top" data-id="element-158" data-mp="1uifpyedsedc" />
                </button>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}